import { Suspense } from 'react';

import { FacebookConversionsAPIClient } from './client';
import { TrackParams } from './track';

export function FacebookConversionsAPI({ params, eventType }: TrackParams) {
  return (
    <Suspense>
      <FacebookConversionsAPIClient params={params} eventType={eventType} />
    </Suspense>
  );
}
